import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Navbar from "../components/Navbar";
import { API } from "../context/AuthContext";
import { toast } from "sonner";

export default function StorePayPal() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [cfg, setCfg] = useState(null);
  const pid = params.get("purchase_id"), orderId = params.get("order_id"), amount = params.get("amount");
  useEffect(() => { axios.get(`${API}/paypal/config`).then(r => setCfg(r.data)).catch(() => setCfg({ configured: false })); }, []);
  return (
    <div className="min-h-screen grain-bg"><Navbar />
      <section className="pt-28 pb-24 max-w-md mx-auto px-5" data-testid="store-paypal">
        <div className="rl-card p-6 text-center">
          <div className="pill-badge inline-flex mb-3">PAGAMENTO PAYPAL</div>
          <h1 className="font-display font-black text-2xl mb-1">Totale €{amount}</h1>
          <p className="text-xs text-slate-500 mb-5">IVA inclusa · crediti accreditati solo dopo conferma server</p>
          {cfg?.configured && cfg.client_id ? (
            <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "EUR", intent: "capture" }}>
              <PayPalButtons style={{ layout: "vertical", color: "black", label: "pay" }} createOrder={async () => orderId}
                onApprove={async () => { try { await axios.post(`${API}/credits/paypal/${orderId}/capture`); nav(`/store/success?purchase_id=${pid}`); } catch (e) { toast.error(e.response?.data?.detail || "Cattura PayPal fallita"); } }}
                onCancel={() => nav("/store?cancelled=1")} onError={() => toast.error("Errore PayPal")} />
            </PayPalScriptProvider>
          ) : <div className="text-sm text-slate-400" data-testid="paypal-unavailable">PayPal non disponibile al momento.</div>}
        </div>
      </section>
    </div>
  );
}
